import {Observable, Observer, Subscription} from 'rxjs';

/**
 * RxJs pipeable operator.
 * Binds the source observable with the passed observables (dependencies),
 * so that subscription/unsubscription for the source will cause subscription/unsubscription for the dependencies.
 * Subscription to the dependencies goes before subscription to the source, and the reverse order for unsubscription.
 * Doesn't change any source's events, just mirrors them to the output.
 * @param {Array<Observable<*>>} dependencyObservables
 * @returns {(source: Observable<T>) => Observable<T>}
 */
export const dependOn = <T>(
    ...dependencyObservables: Array<Observable<any>>
): (source: Observable<T>) => Observable<T> =>
    source =>
        new Observable((observer: Observer<T>) => {
            const dependenciesSubscription = dependencyObservables.reduce(
                (subscription, dependency) => {
                    subscription.add(dependency.subscribe());

                    return subscription;
                },
                new Subscription()
            );
            const sourceSubscription = source.subscribe(observer);

            return () => {
                sourceSubscription.unsubscribe();
                dependenciesSubscription.unsubscribe();
            };
        });
